import { trainCourseEntityName } from '../../../../backend/config/classifiers/entities/defineTrainCourseClassifier';
import { accountEntityName } from '@juvare/contact-management/backend/features/accounts/shared';
import { defineColumns } from '@juvare/platform-shared/features/storage';
import { z } from 'zod';
export const accountTrainCourseSchema = z.object({
    accountId: z.string().uuid(),
    courseId: z.string().uuid(),
    completionDate: z.number(),
});
export const columns = defineColumns({
    accountId: {
        type: 'foreign-key',
        entity: accountEntityName,
    },
    courseId: {
        type: 'foreign-key',
        entity: trainCourseEntityName,
    },
    completionDate: {
        type: 'number-required',
    },
});
